import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_TRANSPORT_NETWORK_INLCM_2 = {
  title: "Populate the logically grouped \nattributes for the modeled device.",
  subtitle: "Transport Network",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_330"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_322"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_transport_net_02_screen.png",
          imageStyle: { position: "absolute", bottom: "328px", right: "103px" },
        },
      ]}
      pageNumber={"ENG_323"}
    />
  ),
};
